import PageNotFound from '@/pages/PageNotFound';

export default function LotteryManagementForbidden() {
  return <PageNotFound statusCode='403' title='Access Denied' subtitle="You don't have permission to Lottery Management" />;
}
